import { FC, useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSSVariableValue } from '../../../../../../_metronic/assets/ts/_utils'

type Props = {
  data: Array<{ store: string; count: number }>
  height?: number
}

const PublicityByStoreChart: FC<Props> = ({ data, height = 400 }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!chartRef.current) return

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, data))
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [data, height])

  return <div ref={chartRef}></div>
}

export { PublicityByStoreChart }

const getChartOptions = (
  height: number,
  data: Array<{ store: string; count: number }>
): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const baseColor = getCSSVariableValue('--bs-success')
  const borderColor = getCSSVariableValue('--bs-gray-200')

  return {
    series: [
      {
        name: 'Quantidade de Publicidades',
        data: data.map((d) => d.count),
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '60%',
        borderRadius: 4,
        dataLabels: {
          position: 'top',
        },
      },
    },
    colors: [baseColor],
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: data.map((d) => d.store),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '11px',
        },
      },
    },
    yaxis: {
      title: {
        style: {
          color: labelColor,
        },
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '11px',
        },
      },
    },
    grid: {
      borderColor: borderColor,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      theme: 'light',
      style: {
        fontSize: '12px',
      },
    },
    fill: {
      type: 'solid',
      opacity: 1,
    },
  }
}
